module.exports = __webpack_public_path__ + "static/media/nosotros06.77a62b63.jpg";